import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { ReactComponent as IconTrash } from 'bootstrap-icons/icons/trash.svg';

const ResourceSelector = ({ 
  resources, 
  selectedResources, 
  onChange, 
  onMenuOpen,
  placeholder, 
  excludeResourceId,
  disabled = false 
}) => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const options = resources?.filter(resource => resource.id !== excludeResourceId).map(resource => ({
    value: resource.id,
    label: resource.label,
    resource: resource
  })) || [];

  const value = resources?.filter(resource => selectedResources?.[resource.id]).map(resource => ({
    value: resource.id,
    label: resource.label,
    resource: resource
  })) || [];

  const handleChange = (selectedOptions) => {
    const selectedIds = selectedOptions ? selectedOptions.map(option => option.value) : [];
    const updatedResources = {};
    selectedIds.forEach(id => {
      updatedResources[id] = true;
    });
    
    onChange(updatedResources);
    
    // Mantener el menú abierto después de la selección
    setMenuOpen(true);
  };

  const handleMenuOpen = () => {
    setMenuOpen(true);
    if (onMenuOpen) {
      onMenuOpen();
    }
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  return (
    <Select
      isMulti={true}
      placeholder={placeholder}
      menuIsOpen={menuOpen}
      hideSelectedOptions={false}
      isDisabled={disabled}
      onMenuOpen={handleMenuOpen}
      onMenuClose={handleMenuClose}
      styles={{
        container: (provided) => ({
          ...provided,
          minWidth: window.innerWidth < 768 ? '200px' : '300px',
          width: '100%',
          maxWidth: '100%'
        }),
        control: (provided) => ({
          ...provided,
          minWidth: window.innerWidth < 768 ? '200px' : '300px',
          maxWidth: '100%'
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999
        }),
        menuPortal: (provided) => ({
          ...provided,
          zIndex: 9999
        })
      }}
      options={options}
      value={value}
      onChange={handleChange}
      components={{
        Option: ({ children, data, isSelected, ...props }) => {
          return (
            <div {...props.innerProps} className="d-flex align-items-center gap-2 p-2" style={{ 
              cursor: 'pointer',
              borderBottom: '1px solid #dee2e6',
              marginLeft: '8px',
              marginRight: '8px'
            }}>
              <div className="d-flex align-items-center gap-2 w-100">
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={isSelected}
                  readOnly
                  style={{ margin: 0 }}
                />
                <div className="d-flex flex-column">
                  <div className="text-truncate d-flex align-items-center gap-2">
                    {data.resource.label}
                    {data.resource.deleted && (
                      <IconTrash width="16" height="16" className="text-danger" data-tooltip-id="app-tooltip" data-tooltip-content={t("deleted")} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )
        }
      }}
    />
  );
};

export default ResourceSelector;
